/* ============================================================
   SCENT HARMONY · Interacciones del cart drawer (delegadas en
   document para sobrevivir a los re-render de secciones de Dawn).
   4c: selector de decant · 4d: bolsa de regalo + tarjeta personalizada.
   ============================================================ */
(function () {
  'use strict';
  if (window.shCartBound) return;
  window.shCartBound = true;

  function jpost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      // Shopify responde 422 con {status, message, description} (agotado, límite
      // de cantidad…): sin este reject, el flujo seguía el camino de éxito y el
      // comprador no veía nada.
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) { throw e; });
      return r.json();
    });
  }

  // Aviso visible de error del carrito (toast de marca, role=alert).
  // Shopify ya localiza 'description'; el fallback es el cartStrings de Dawn.
  var noticeTimer;
  function cartNotice(err) {
    var msg = (err && typeof err.description === 'string' && err.description) ||
              (err && typeof err.message === 'string' && err.status && err.message) ||
              (window.cartStrings && window.cartStrings.error) ||
              'There was an error while updating your cart. Please try again.';
    var el = document.querySelector('.sh-cart-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sh-cart-toast';
      el.setAttribute('role', 'alert');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 5000);
  }
  window.shCartNotice = cartNotice;

  function updateAttributes(attrs) {
    return jpost('/cart/update.js', { attributes: attrs });
  }

  function setCount(n) {
    document.querySelectorAll('.sh-cart__count').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  // Fly-to-cart: una esfera vuela desde el botón al ícono del carrito (fiel al
  // prototipo). land() = pulso del ícono + pop del contador. Respeta reduced-motion.
  function flyToCart(sourceEl) {
    var icon = document.querySelector('.sh-cart');
    if (!icon) return;
    function land() {
      icon.classList.remove('sh-cart-bump'); void icon.offsetWidth; icon.classList.add('sh-cart-bump');
      var badge = icon.querySelector('.sh-cart__count');
      if (badge) { badge.classList.remove('sh-count-pop'); void badge.offsetWidth; badge.classList.add('sh-count-pop'); }
      setTimeout(function () { icon.classList.remove('sh-cart-bump'); }, 520);
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var s = sourceEl && sourceEl.getBoundingClientRect();
    var t = icon.getBoundingClientRect();
    if (reduce || !s || !s.width || !t.width) { land(); return; }
    var sx = s.left + s.width / 2, sy = s.top + s.height / 2;
    var dx = (t.left + t.width / 2) - sx, dy = (t.top + t.height / 2) - sy;
    var dot = document.createElement('span');
    dot.className = 'sh-fly-dot';
    dot.style.left = sx + 'px';
    dot.style.top = sy + 'px';
    dot.style.setProperty('--dx', dx + 'px');
    dot.style.setProperty('--dy', dy + 'px');
    document.body.appendChild(dot);
    dot.getBoundingClientRect(); // reflow
    dot.classList.add('is-flying');
    setTimeout(function () { dot.remove(); land(); }, 700);
  }

  // Reemplaza el contenido del drawer con la sección re-renderizada por el server.
  function applyDrawerSection(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('.drawer__inner');
    var freshHost = parsed.querySelector('cart-drawer');
    var host = document.querySelector('cart-drawer');
    var cur = host && host.querySelector('.drawer__inner');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    // Sincronizar la clase is-empty del HOST desde el render fresco. Dawn marca
    // is-empty en <cart-drawer> (no en .drawer__inner) y su CSS oculta los ítems;
    // sin esto, añadir a un carrito vacío por AJAX deja el drawer "en blanco".
    if (host && freshHost) host.classList.toggle('is-empty', freshHost.classList.contains('is-empty'));
  }

  // El HTML que devuelve la Section Rendering API se renderiza contra la URL que
  // se le pasa en `sections_url`, NO contra la ruta del POST. Sin él, Shopify usa
  // el idioma por DEFECTO: un comprador en /es/ añadía la bolsa y el drawer entero
  // (barra, "Incluido en tu pedido", chips del decant, botón de pago) le saltaba a
  // INGLÉS hasta recargar. Medido: sections_url:'/es/' devuelve "Incluido en tu
  // pedido"; sin él, y también con POST a /es/cart/add.js, devuelve "Included with
  // your order" — o sea que poner el prefijo en la URL del POST NO arregla nada.
  function sectionsUrl() {
    return window.location.pathname + window.location.search;
  }

  // Bolsa de regalo: add-on de pago (línea real). Añade/quita y re-renderiza el drawer.
  function toggleGiftBag(variantId, add) {
    var url = add ? '/cart/add.js' : '/cart/change.js';
    var body = add
      ? { items: [{ id: variantId, quantity: 1 }], sections: ['cart-drawer'], sections_url: sectionsUrl() }
      : { id: String(variantId), quantity: 0, sections: ['cart-drawer'], sections_url: sectionsUrl() };
    return jpost(url, body).then(function (data) {
      applyDrawerSection(data.sections && data.sections['cart-drawer']);
      if (typeof data.item_count === 'number') {
        setCount(data.item_count);
      } else {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { setCount(c.item_count); })
          .catch(function () {});
      }
    });
  }

  // Cross-sell: añadir un producto sugerido (single-variant) + re-render.
  function addVariant(variantId) {
    return jpost('/cart/add.js', { items: [{ id: variantId, quantity: 1 }], sections: ['cart-drawer'], sections_url: sectionsUrl() })
      .then(function (data) {
        applyDrawerSection(data.sections && data.sections['cart-drawer']);
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { setCount(c.item_count); })
          .catch(function () {});
      });
  }

  // ---- Clicks: quick-add de tarjetas + chips de decant + "Añadir" del cross-sell ----
  document.addEventListener('click', function (e) {
    // Quick-add desde tarjetas (The Edit): añade directo, vuela al carrito y abre el drawer.
    var quickAdd = e.target.closest('[data-sh-quickadd]');
    if (quickAdd && quickAdd.tagName === 'BUTTON') {
      e.preventDefault();
      quickAdd.classList.add('is-loading');
      flyToCart(quickAdd);
      addVariant(quickAdd.getAttribute('data-sh-quickadd')).then(function () {
        quickAdd.classList.remove('is-loading');
        setTimeout(openCartDrawer, 480);
      }).catch(function (err) { quickAdd.classList.remove('is-loading'); cartNotice(err); });
      return;
    }

    var addBtn = e.target.closest('[data-sh-add]');
    if (addBtn && addBtn.tagName === 'BUTTON') {
      e.preventDefault();
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
      flyToCart(addBtn);
      addVariant(addBtn.getAttribute('data-sh-add')).then(function () {
        // En la página /cart el listado no se re-renderiza por AJAX — recargar
        if (document.getElementById('main-cart-footer')) window.location.reload();
      }).catch(function (err) {
        addBtn.disabled = false;
        addBtn.classList.remove('is-loading');
        cartNotice(err);
      });
      return;
    }

    var chip = e.target.closest('[data-decant-aroma]');
    if (!chip) return;
    var aroma = chip.getAttribute('data-decant-aroma'); // valor canónico (fulfillment)
    var aromaLabel = chip.getAttribute('data-decant-label') || aroma; // display localizado
    var group = chip.closest('.sh-cart-decant__chips');
    var already = chip.classList.contains('is-active');
    // 29-ago (auditoría): DESELECCIONAR volvía a dejar el atributo VACÍO, que
    // es justo la regla "vacío = sorpresa" que el dueño pidió eliminar — y como
    // /cart/update.js va sin `sections`, no hay re-render y cleanupOrphanAttrs
    // tampoco lo rescataba: si pagaba ahí, el pedido salía sin muestra escrita.
    // Deseleccionar = volver al default explícito "Sorpréndeme", igual que un
    // render limpio (sh-cart-included.liquid marca ese chip activo sin elección).
    var surpriseChip = group && group.querySelector('.sh-cart-decant__chip--surprise');
    // 22-sep (pedido del dueño): «Sorpréndeme» NO se desmarca tocándolo. Siempre
    // tiene que haber UNA opción marcada; solo se sale de él eligiendo un frasco.
    // Antes, tocarlo estando marcado dejaba los cinco apagados y el atributo vacío.
    if (already && chip === surpriseChip) return;
    var backToSurprise = already && surpriseChip && surpriseChip !== chip;
    if (group) {
      group.querySelectorAll('.sh-cart-decant__chip').forEach(function (c) {
        var on = backToSurprise ? c === surpriseChip : (c === chip && !already);
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    // Reflejar la selección en el resumen "Complimentary scent sample" (sin re-render)
    var details = chip.closest('.sh-cart-decant');
    var meta = details && details.querySelector('[data-sh-decant-meta]');
    if (meta && group) {
      // El tamaño vive en su propia insignia (.sh-cart-incl__ml) y depende del
      // total del carrito, no del aroma: aquí solo se refleja el aroma elegido.
      if (backToSurprise) {
        meta.textContent = '✦ ' + (surpriseChip.getAttribute('data-decant-label') || '');
      } else if (already) {
        meta.textContent = group.getAttribute('data-sh-decant-choose') || '';
      } else {
        meta.textContent = (chip === surpriseChip ? '✦ ' : '') + aromaLabel;
      }
    }
    // 22-sep · Los frasquitos de la fila cerrada: con «Sorpréndeme» se ven los
    // cuatro (invitan a elegir); con un perfume elegido, solo el suyo, y la
    // llamada pasa de «Elige la tuya» a «Cambiar» (lo hace el CSS con .has-sel).
    var pick = details && details.querySelector('[data-sh-decant-thumbs]');
    if (pick) {
      var selVal = (already || chip === surpriseChip) ? '' : aroma;
      pick.classList.toggle('has-sel', !!selVal);
      pick.querySelectorAll('[data-for]').forEach(function (im) {
        im.classList.toggle('is-sel', im.getAttribute('data-for') === selVal);
      });
    }
    // Al ELEGIR un aroma, colapsa la fila a su forma compacta (con "Change");
    // al deseleccionar, la deja abierta para seguir eligiendo.
    if (details && !already) { details.open = false; }
    // El valor que VIAJA al pedido: al deseleccionar vuelve al default escrito
    // ("Sorpréndeme"), nunca a vacío — la regla "vacío = sorpresa" se retiró.
    var attrValue = already ? (backToSurprise ? surpriseChip.getAttribute('data-decant-aroma') : '') : aroma;
    updateAttributes({ 'Decant de cortesía': attrValue }).catch(cartNotice);
  });

  // ---- Change: bolsa de regalo + "es un regalo" ----
  // En CAPTURA y con stopPropagation: nuestros controles (checkboxes, textarea,
  // chips) viven DENTRO de <cart-drawer-items> y Dawn escucha 'change' ahí
  // asumiendo que todo viene de un input de cantidad → TypeError en
  // resetQuantityInput + "Hubo un error al actualizar el carrito". El evento
  // de un control nuestro NO debe llegar a Dawn; los inputs de cantidad de
  // Dawn pasan intactos.
  document.addEventListener('change', function (e) {
    var own = e.target.closest('.sh-cart-gift, .sh-cart-incl, .sh-cart-decant, [data-sh-cart-decant], .sh-pair');
    if (!own) return;
    e.stopPropagation();
    var gb = e.target.closest('[data-sh-giftbag]');
    if (gb) {
      gb.disabled = true;
      toggleGiftBag(gb.getAttribute('data-variant'), gb.checked)
        .catch(function (err) { if (gb.isConnected) gb.checked = !gb.checked; cartNotice(err); })
        .then(function () {
          // En el drawer el checkbox se re-renderiza; en la página /cart no hay
          // re-render, así que se rehabilita (si sigue en el DOM) y se refresca
          // el listado para reflejar la línea añadida/quitada.
          if (gb.isConnected) gb.disabled = false;
          if (document.getElementById('main-cart-footer') && !gb.closest('cart-drawer')) window.location.reload();
        });
      return;
    }
    var gm = e.target.closest('[data-sh-giftmsg]');
    if (gm) {
      var wrap = gm.closest('.sh-cart-gift__giftwrap');
      var field = wrap && wrap.querySelector('.sh-cart-gift__msg');
      if (field) { if (gm.checked) { field.removeAttribute('hidden'); } else { field.setAttribute('hidden', ''); } }
      var attrs = { 'Es un regalo': gm.checked ? 'sí' : '' };
      if (!gm.checked) {
        attrs['Mensaje de regalo'] = '';
      } else if (field) {
        // Desmarcar borra el atributo pero NO vacía el textarea (solo se oculta).
        // Al volver a marcar, el cliente veía su mensaje escrito y el pedido salía
        // SIN él: el texto solo se guarda en el evento de escritura (línea 478),
        // que aquí no se dispara. Se reenvía lo que haya escrito.
        var ta = field.querySelector('[data-sh-giftmsg-text]');
        if (ta && ta.value.trim()) attrs['Mensaje de regalo'] = ta.value;
      }
      updateAttributes(attrs).catch(cartNotice);
    }
  }, true);

  // ---- Menos a cero = eliminar la línea ----
  // Dawn valida contra quantity_rule.min (1) y muestra "mínimo 1" al bajar de
  // 1 → interceptamos el clic del "−" en CAPTURA cuando la cantidad es 1 y
  // disparamos el botón Eliminar real de esa línea (drawer y página /cart).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('quantity-input button[name="minus"]');
    if (!btn) return;
    if (!btn.closest('cart-drawer, #main-cart-items, cart-items')) return;
    var input = btn.closest('quantity-input').querySelector('.quantity__input');
    if (!input || parseInt(input.value, 10) > 1) return;
    e.preventDefault();
    e.stopPropagation();
    var idx = input.dataset.index;
    // El botón Eliminar tiene que ser el de ESTA línea. Antes se buscaba por id
    // en TODO el documento y con CartDrawer-* por delante — pero en /cart el
    // drawer también está montado (medido: conviven CartDrawer-Remove-1..N y
    // Remove-1..N), así que en la página de carrito ganaba siempre el del
    // drawer. Y el remove del drawer solo re-renderiza .drawer__inner y el
    // contador (CartDrawerItems.getSectionsToRender), NO main-cart-items ni
    // main-cart-footer: la línea se borraba en el servidor pero seguía a la
    // vista con el subtotal viejo, y el siguiente "−" borraba OTRA línea.
    // Se busca dentro del envoltorio de la propia fila, que las dos
    // superficies comparten (.cart-item__quantity-wrapper).
    var wrap = btn.closest('.cart-item__quantity-wrapper');
    var rm = wrap && wrap.querySelector('cart-remove-button');
    if (!rm) {
      var scope = btn.closest('cart-drawer-items, cart-items') || document;
      rm = scope.querySelector('#CartDrawer-Remove-' + idx) || scope.querySelector('#Remove-' + idx);
    }
    if (!rm) return;
    var clickable = rm.querySelector('button, a') || rm;
    clickable.click();
  }, true);

  // ---- Higiene tras cada cambio del carrito ----
  // 1) Sin perfume en el pedido, el aroma elegido del decant NO debe viajar al
  //    checkout (fulfillment lo leería en un pedido sin muestra de cortesía).
  // 2) Si solo queda la bolsa de regalo (add-on oculto), se retira sola: un
  //    carrito con únicamente el add-on es un estado roto.
  var cleanupBusy = false;
  function cartCleanup() {
    if (cleanupBusy) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var items = c.items || [];
        // ESPEJO de snippets/sh-tipos-muestra.liquid — si cambia allí, cambia aquí.
        // 'Set' = coffret precintado de marca · 'Gift Kit' = el que arma la casa.
        // Fuera: 'Discovery Set' (los kits de viales YA son muestras), brumas y velas.
        var TIPOS_MUESTRA = ['Perfume', 'Set', 'Gift Kit'];
        // 24-oct · La muestra de 5 ml (variante «5 ml») NO cuenta: solo el frasco da muestra de cortesía.
        var hasPerfume = items.some(function (i) { return i.variant_title !== '5 ml' && TIPOS_MUESTRA.indexOf(i.product_type || '') > -1; });
        // 25-sep (revisión nocturna): antes limpiaba el atributo y SALÍA sin mirar la bolsa,
        // así que al quitar el último perfume la bolsa de regalo se quedaba sola y se cobraba.
        // Ahora las dos limpiezas van en cadena, una detrás de otra.
        var tareas = [];
        var at = c.attributes || {};
        if (!hasPerfume && (at['Decant de cortesía'] || at['Tamaño de la muestra'])) {
          tareas.push(function () { return updateAttributes({ 'Decant de cortesía': '', 'Tamaño de la muestra': '' }); });
        }
        var onlyBag = items.length > 0 && items.every(function (i) { return i.handle === 'sh-gift-bag'; });
        if (onlyBag) {
          tareas.push(function () { return toggleGiftBag(items[0].variant_id, false); });
        }
        if (!tareas.length) return;
        cleanupBusy = true;
        tareas.reduce(function (p, t) { return p.then(t).catch(function () {}); }, Promise.resolve())
          .then(function () { cleanupBusy = false; });
      })
      .catch(function () {});
  }
  // 3) En /cart el drawer TAMBIÉN está montado, pero las acciones de la página
  //    (CartItems) solo re-renderizan main-cart-items, main-cart-footer y el
  //    contador — nunca cart-drawer. Medido: quitar una línea en /cart dejaba el
  //    drawer con 3 líneas y $307 mientras el carrito real tenía 2 y $218, y el
  //    icono del carrito lo abría así de rancio encima de la página correcta.
  //    Se repinta desde la raíz LOCALIZADA (Shopify.routes.root), que es la única
  //    que devuelve la sección: /cart?sections=… responde el JSON del carrito.
  //    Solo en la página de carrito: en el resto el drawer ya se repinta solo.
  function refreshDrawerOnCartPage() {
    if (!document.getElementById('main-cart-footer')) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { applyDrawerSection(d && d['cart-drawer']); })
      .catch(function () {});
  }

  function bindCartCleanup() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, cartCleanup);
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshDrawerOnCartPage);
      // 29-ago (auditoría): en la PÁGINA /cart la recomendación automática se
      // apagaba para siempre al tocar una cantidad. El bloque lo pinta
      // main-cart-footer, que Dawn re-renderiza en cada cambio; el placeholder
      // nuevo llega `hidden` y sin data-loaded, y el MutationObserver que lo
      // repuebla cuelga SOLO de <cart-drawer> — que ahí no muta. En el drawer
      // nunca se vio porque ese observer sí dispara.
      subscribe(PUB_SUB_EVENTS.cartUpdate, populatePairAuto);
    } else {
      setTimeout(bindCartCleanup, 250);
    }
  }
  bindCartCleanup();

  // ============================================================
  // Quick view (mini ventana de compra) — abre desde [data-sh-quickview]
  // (sh-card / sh-edit). Reutiliza addVariant() + abre el cart drawer.
  // ============================================================
  var qv = document.getElementById('sh-quickview');
  var qvVeil = document.querySelector('[data-sh-qv-veil]');
  var qvState = { url: '#', variant: '', multi: false, trigger: null };

  // Focus trap: Tab no debe escaparse del diálogo hacia la página de fondo.
  function shTrapFocus(container) {
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var els = container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      var vis = Array.prototype.filter.call(els, function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && (document.activeElement === first || !container.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !container.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    }
    document.addEventListener('keydown', onKey, true);
    return function () { document.removeEventListener('keydown', onKey, true); };
  }
  window.shTrapFocus = shTrapFocus;

  function qvSet(sel, val) { var el = qv && qv.querySelector(sel); if (el) el.textContent = val || ''; }

  function openCartDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    if (typeof d.open === 'function') { try { d.open(); return; } catch (e) {} }
    d.classList.remove('is-empty');
    d.setAttribute('open', '');
    d.classList.add('active', 'animate');
  }

  function openQuickView(t) {
    if (!qv) return;
    var d = t.dataset;
    qvState.url = d.url || '#';
    qvState.variant = d.variant || '';
    qvState.multi = d.multi === 'true';
    qvState.trigger = t;
    qvSet('[data-sh-qv-brand]', d.brand);
    qvSet('[data-sh-qv-name]', d.name);
    qvSet('[data-sh-qv-type]', d.type);
    // Precio con oferta: si el trigger trae data-compare, tachado + precio actual
    var qvPrice = qv.querySelector('[data-sh-qv-price]');
    if (qvPrice) {
      if (d.compare) {
        qvPrice.classList.add('is-sale');
        qvPrice.innerHTML = '<s class="sh-qv__was"></s><span class="sh-qv__now"></span>';
        qvPrice.querySelector('.sh-qv__was').textContent = d.compare;
        qvPrice.querySelector('.sh-qv__now').textContent = d.price || '';
      } else {
        qvPrice.classList.remove('is-sale');
        qvPrice.textContent = d.price || '';
      }
    }
    // Insignia −X% sobre el visual (misma píldora que en las tarjetas)
    var qvSale = qv.querySelector('[data-sh-qv-saletag]');
    if (qvSale) {
      if (d.pct) {
        qvSale.textContent = '−' + d.pct + '%';
        qvSale.removeAttribute('hidden');
      } else {
        qvSale.setAttribute('hidden', '');
      }
    }
    qvSet('[data-sh-qv-desc]', d.desc);
    var img = qv.querySelector('[data-sh-qv-img]');
    var emblem = qv.querySelector('[data-sh-qv-emblem]');
    if (d.img && img) {
      img.src = d.img; img.alt = d.name || '';
      img.removeAttribute('hidden'); if (emblem) emblem.setAttribute('hidden', '');
    } else {
      if (img) img.setAttribute('hidden', ''); if (emblem) emblem.removeAttribute('hidden');
    }
    var full = qv.querySelector('[data-sh-qv-full]');
    if (full) full.setAttribute('href', qvState.url);
    var addBtn = qv.querySelector('[data-sh-qv-add]');
    if (addBtn) {
      // Agotado: botón deshabilitado con "Sold out" (antes quedaba activo y el
      // add del 422 moría en silencio). "Choose options" navega al PDP, así que
      // con multi-variante se deja activo aunque la primera variante esté out.
      var soldOut = d.available === 'false' && !qvState.multi;
      addBtn.disabled = soldOut;
      if (soldOut) addBtn.setAttribute('aria-disabled', 'true');
      else addBtn.removeAttribute('aria-disabled');
      addBtn.textContent = soldOut
        ? (addBtn.getAttribute('data-soldout') || 'Sold out')
        : (qvState.multi ? (addBtn.getAttribute('data-choose') || 'Choose options') : (addBtn.getAttribute('data-add') || addBtn.textContent));
    }
    qv.removeAttribute('hidden'); if (qvVeil) qvVeil.removeAttribute('hidden');
    void qv.offsetWidth; // reflow → la transición corre sin depender de rAF (robusto en tabs ocultas)
    qv.classList.add('is-open'); if (qvVeil) qvVeil.classList.add('is-open');
    qv.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = qv.querySelector('[data-sh-qv-close]');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 60);
    if (qvState.untrap) qvState.untrap();
    qvState.untrap = shTrapFocus(qv);
  }

  function closeQuickView() {
    if (!qv) return;
    if (qvState.untrap) { qvState.untrap(); qvState.untrap = null; }
    qv.classList.remove('is-open'); if (qvVeil) qvVeil.classList.remove('is-open');
    qv.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { qv.setAttribute('hidden', ''); if (qvVeil) qvVeil.setAttribute('hidden', ''); }, 400);
    if (qvState.trigger && qvState.trigger.focus) { qvState.trigger.focus({ preventScroll: true }); qvState.trigger = null; }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sh-quickview]');
    if (trigger) { e.preventDefault(); e.stopPropagation(); openQuickView(trigger); return; }
    if (e.target.closest('[data-sh-qv-close]') || e.target.closest('[data-sh-qv-veil]')) { closeQuickView(); return; }
    var qvAdd = e.target.closest('[data-sh-qv-add]');
    if (qvAdd) {
      if (qvState.multi) { window.location.href = qvState.url; return; }
      if (!qvState.variant) return;
      qvAdd.disabled = true; qvAdd.classList.add('is-loading');
      flyToCart(qvAdd);
      addVariant(qvState.variant).then(function () {
        qvAdd.disabled = false; qvAdd.classList.remove('is-loading');
        closeQuickView();
        setTimeout(openCartDrawer, 220);
      }).catch(function (err) { qvAdd.disabled = false; qvAdd.classList.remove('is-loading'); cartNotice(err); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && qv && qv.classList.contains('is-open')) closeQuickView();
  });

  // ---- Input: textarea del mensaje de regalo (con contador + debounce) ----
  var msgTimer;
  document.addEventListener('input', function (e) {
    var t = e.target.closest('[data-sh-giftmsg-text]');
    if (!t) return;
    var wrap = t.closest('.sh-cart-gift__giftwrap');
    var cnt = wrap && wrap.querySelector('[data-sh-giftmsg-count]');
    if (cnt) cnt.textContent = t.value.length;
    clearTimeout(msgTimer);
    msgTimer = setTimeout(function () {
      updateAttributes({ 'Mensaje de regalo': t.value }).catch(cartNotice);
    }, 500);
  });

  // Fly-to-cart también para los add nativos de Dawn (PLP quick-add, PDP, sticky).
  // Solo animación; no interfiere con el submit AJAX del <product-form>.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-form__submit, product-form button[name="add"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    flyToCart(btn);
  }, true);

  // Atributos huérfanos: si el carrito ya no cumple la regla, el atributo
  // elegido antes quedaría pegado al pedido y fulfillment actuaría mal.
  // · Sin perfume → limpiar 'Decant de cortesía' (el selector no se renderiza).
  // · Tarjeta NO elegible (sin perfume y bajo el umbral) o carrito vacío →
  //   limpiar 'Es un regalo' + 'Mensaje de regalo' (el checkbox sale disabled).
  var attrCleanupBusy = false;
  // 29-ago (auditoría): la guarda de salida temprana de abajo era INALCANZABLE
  // (`!needDecant` ya implica que existe `sizeEl`), así que CADA mutación del
  // drawer lanzaba un fetch('/cart.js'). Medido en el dev: 6 peticiones de
  // carrito por un solo "añadir", tres de ellas este mismo fetch repetido.
  // Se cachea la firma del estado que el DOM pide: si no ha cambiado desde la
  // última pasada, ya está sincronizado y no hay nada que consultar.
  var lastSyncKey = null;
  function cleanupOrphanAttrs() {
    if (attrCleanupBusy) return;
    var host = document.querySelector('cart-drawer');
    if (!host) return;
    var needDecant = !host.querySelector('[data-sh-cart-decant]'); // sin perfume
    var gw = host.querySelector('.sh-cart-gift__giftwrap');
    var needGift = !gw || gw.classList.contains('is-disabled'); // no elegible / vacío
    // El TAMAÑO de la muestra (2 ml / 5 ml) lo calcula Liquid en cada render
    // (decant_base vs umbral) y lo deja en data-sh-decant-size, pero hasta el
    // 29-ago NO viajaba al pedido: el dueño no tenía forma de saber qué vial
    // meter. Se escribe como atributo canónico ES (fulfillment, como el aroma)
    // y se re-sincroniza en cada re-render del drawer, porque cambia SOLO al
    // cruzar el umbral aunque el cliente no toque nada.
    var sizeEl = host.querySelector('[data-sh-decant-size]');
    var wantSize = sizeEl ? sizeEl.getAttribute('data-sh-decant-size') : '';
    var syncKey = (needDecant ? 'D' : '-') + (needGift ? 'G' : '-') + '|' + wantSize;
    if (syncKey === lastSyncKey) return;
    attrCleanupBusy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var a = (c && c.attributes) || {};
        var upd = {};
        if (needDecant && a['Decant de cortesía']) upd['Decant de cortesía'] = '';
        if (needDecant && a['Tamaño de la muestra']) upd['Tamaño de la muestra'] = '';
        if (!needDecant && sizeEl && wantSize && a['Tamaño de la muestra'] !== wantSize) upd['Tamaño de la muestra'] = wantSize;
        // 29-ago (pedido del dueño): el default "Sorpréndeme" viaja ESCRITO al
        // pedido — antes el atributo vacío significaba sorpresa y él tenía que
        // acordarse de la regla. Con perfume y sin aroma elegido se escribe el
        // valor canónico; deseleccionar un aroma también vuelve aquí (la UI ya
        // marca Sorpréndeme como activo cuando no hay elección).
        if (!needDecant && !a['Decant de cortesía']) upd['Decant de cortesía'] = 'Sorpréndeme';
        if (needGift && (a['Es un regalo'] || a['Mensaje de regalo'])) {
          upd['Es un regalo'] = '';
          upd['Mensaje de regalo'] = '';
          // Reflejar en la UI sin esperar al próximo render
          if (gw) {
            var chk = gw.querySelector('[data-sh-giftmsg]');
            if (chk) chk.checked = false;
            var field = gw.querySelector('.sh-cart-gift__msg');
            if (field) field.setAttribute('hidden', '');
          }
        }
        if (Object.keys(upd).length) return updateAttributes(upd);
      })
      .then(function () { lastSyncKey = syncKey; })
      .catch(function () {})
      .then(function () { attrCleanupBusy = false; });
  }
  if ('MutationObserver' in window) {
    var dcHost = document.querySelector('cart-drawer');
    if (dcHost) new MutationObserver(function () { cleanupOrphanAttrs(); }).observe(dcHost, { childList: true, subtree: true });
  }
  cleanupOrphanAttrs();

  // ============================================================
  // Upsell automático (Product Recommendations API). Cuando el snippet
  // sh-cart-upsell no tiene producto curado válido, deja un placeholder
  // [data-sh-pair-auto] oculto; aquí se rellena con la primera
  // recomendación del perfume ancla que no esté ya en el carrito.
  // El guard data-loaded evita bucles con el MutationObserver: cada
  // re-render del drawer crea un placeholder fresco y se re-puebla.
  // ============================================================
  function populatePairAuto() {
    document.querySelectorAll('[data-sh-pair-auto]:not([data-loaded])').forEach(function (box) {
      box.setAttribute('data-loaded', '1');
      var anchor = box.getAttribute('data-anchor');
      if (!anchor) return;
      var exclude = [];
      try { exclude = JSON.parse(box.getAttribute('data-exclude') || '[]'); } catch (e) {}
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(anchor) + '&limit=6&intent=related')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          var rec = (data.products || []).filter(function (p) {
            // El add-on de la bolsa NUNCA se recomienda: es interno, se añade con
            // su casilla en este mismo drawer y ofrecerlo como cross-sell sería
            // vender dos veces lo mismo. sh-card.liquid y sh-wishlist-body.liquid
            // ya lo filtran con esta misma regla; aquí faltaba.
            var tags = p.tags || [];
            if (p.type === 'Add-on' || tags.indexOf('hidden-addon') > -1) return false;
            return p.available && exclude.indexOf(p.id) === -1;
          })[0];
          if (!rec || !box.isConnected) return;
          var name = box.querySelector('[data-sh-pair-name]');
          if (name) { name.textContent = rec.title; name.setAttribute('href', rec.url); }
          var media = box.querySelector('[data-sh-pair-media]');
          if (media) {
            media.setAttribute('href', rec.url);
            media.setAttribute('aria-label', rec.title);
            if (rec.featured_image) {
              var img = document.createElement('img');
              img.src = rec.featured_image + (rec.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=140';
              img.alt = rec.title;
              img.width = 70; img.height = 70; img.loading = 'lazy';
              media.textContent = '';
              media.appendChild(img);
            }
          }
          var price = box.querySelector('[data-sh-pair-price]');
          if (price) {
            var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
            try {
              price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(rec.price / 100);
            } catch (e) { price.textContent = '$' + (rec.price / 100).toFixed(2); }
          }
          var btn = box.querySelector('[data-sh-pair-btn]');
          if (btn) {
            if (rec.variants && rec.variants.length === 1) {
              btn.setAttribute('data-sh-add', rec.variants[0].id);
            } else {
              // Multivariante: no se puede añadir a ciegas — el botón lleva al PDP
              var link = document.createElement('a');
              link.className = btn.className;
              link.setAttribute('href', rec.url);
              link.textContent = btn.getAttribute('data-choose-label') || btn.textContent;
              btn.replaceWith(link);
            }
          }
          box.removeAttribute('hidden');
        })
        .catch(function () {});
    });
  }
  populatePairAuto();
  if ('MutationObserver' in window) {
    var pairHost = document.querySelector('cart-drawer');
    if (pairHost) new MutationObserver(function () { populatePairAuto(); }).observe(pairHost, { childList: true, subtree: true });
  }

  // ============================================================
  // La recomendación ROTA (16-sep · decisión del dueño: «que el carrito no
  // deje de recomendar»). `sh-cart-upsell.liquid` deja en cada hueco
  // [data-sh-pair-slot] varias tarjetas apiladas; aquí se va pasando de una a
  // otra con el deslizamiento que define sh-cart.css.
  //
  // Tres cosas que NO son adorno:
  //  · Se para mientras el ratón o el teclado están encima del bloque. Si la
  //    tarjeta cambiara justo al ir a pulsar "Añadir", el cliente añadiría
  //    otro producto: es el fallo clásico de los carruseles con botón.
  //  · Se para si el drawer está cerrado o la pestaña en segundo plano; no
  //    tiene sentido gastar giros que nadie ve.
  //  · Dawn reemplaza .drawer__inner entero en cada cambio del carrito, así que
  //    los huecos son elementos NUEVOS: el observador vuelve a arrancarlos y
  //    los temporizadores viejos se apagan solos al ver que su hueco ya no está
  //    en el documento (isConnected).
  // ============================================================
  (function () {
    var INTERVALO = 5200; // ms entre tarjetas
    var SALIDA = 520;     // ms que tarda en irse la que sale (ver --dur-slow)
    var PAUSA_TOQUE = 9000; // ms parado tras tocar el bloque
    var relojes = [];
    var pausaHasta = 0;

    // En móvil no hay :hover que frene la rotación: si cambia entre que el dedo
    // baja y el clic se resuelve, el toque cae en una tarjeta que ya no está.
    // Cualquier toque dentro del bloque lo deja quieto unos segundos.
    document.addEventListener('pointerdown', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.sh-pair')) pausaHasta = Date.now() + PAUSA_TOQUE;
    }, true);

    function visible(el) {
      return el.isConnected && el.offsetParent !== null;
    }

    function girar(slot) {
      var slides = slot.querySelectorAll('.sh-pair__slide');
      if (slides.length < 2) return;
      var i = 0;
      for (var k = 0; k < slides.length; k++) {
        if (slides[k].classList.contains('is-on')) i = k;
      }
      var sale = slides[i];
      var entra = slides[(i + 1) % slides.length];
      sale.classList.remove('is-on');
      sale.classList.add('is-out');
      entra.classList.add('is-on');
      setTimeout(function () { sale.classList.remove('is-out'); }, SALIDA);
    }

    function arrancar() {
      relojes = relojes.filter(function (r) {
        if (r.slot.isConnected) return true;
        clearTimeout(r.to); clearInterval(r.iv);
        return false;
      });
      var slots = document.querySelectorAll('[data-sh-pair-slot]:not([data-sh-ready])');
      Array.prototype.forEach.call(slots, function (slot) {
        var slides = slot.querySelectorAll('.sh-pair__slide');
        if (!slides.length) return;
        // El estado inicial se pinta en la MISMA pasada que data-sh-ready: el
        // hueco es un elemento recién insertado y todavía no tiene estilo
        // calculado, así que no hay transición que arranque sola ni parpadeo.
        slides[0].classList.add('is-on');
        slot.setAttribute('data-sh-ready', '1');
        if (slides.length < 2) return;
        var reloj = { slot: slot, to: 0, iv: 0 };
        relojes.push(reloj);
        reloj.to = setTimeout(function () {
          reloj.iv = setInterval(function () {
            if (!slot.isConnected) { clearInterval(reloj.iv); return; }
            // Basta con mirar si el hueco se ve: con el drawer cerrado no tiene
            // offsetParent. (No se usa document.hidden: el navegador ya frena
            // los temporizadores en segundo plano, y en la ventana de vista
            // previa document.hidden es SIEMPRE true, así que nada giraría.)
            if (!visible(slot) || Date.now() < pausaHasta) return;
            var bloque = slot.closest('.sh-pair');
            // Solo para el foco de TECLADO (:focus-visible). Con `contains(activeElement)`
            // bastaba un clic en "Añadir" para dejar la rotación parada para siempre.
            if (bloque && (bloque.matches(':hover') || bloque.querySelector(':focus-visible'))) return;
            girar(slot);
          }, INTERVALO);
        }, parseInt(slot.getAttribute('data-delay'), 10) || 0);
      });
    }

    arrancar();
    if ('MutationObserver' in window) {
      // El drawer y la página del carrito se re-renderizan por sitios distintos.
      ['cart-drawer', '#main-cart-footer', '#main-cart-items'].forEach(function (sel) {
        var host = document.querySelector(sel);
        if (host) new MutationObserver(arrancar).observe(host, { childList: true, subtree: true });
      });
    }
  })();

  // Pulso del subtotal al cambiar (del prototipo). Dawn/applyDrawerSection
  // reemplazan .drawer__inner entero → observamos el host y pulsamos SOLO si
  // el valor cambió (no al abrir/cerrar el drawer).
  (function () {
    var lastTotal = null;
    function checkTotal() {
      var el = document.querySelector('cart-drawer .totals__total-value');
      if (!el) { lastTotal = null; return; }
      var v = el.textContent.trim();
      if (lastTotal !== null && v !== lastTotal) {
        el.classList.remove('sh-cart-total-bump');
        void el.offsetWidth; // reflow para reiniciar la animación
        el.classList.add('sh-cart-total-bump');
      }
      lastTotal = v;
    }
    var host = document.querySelector('cart-drawer');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(checkTotal).observe(host, { childList: true, subtree: true });
      checkTotal();
    }
  })();

  // Crecimiento de la barra de progreso. Mismo problema y misma solución que el
  // pulso del subtotal: Dawn/applyDrawerSection reemplazan .drawer__inner entero,
  // así que el .sh-cart-progress__fill es un elemento NUEVO en cada cambio del
  // carrito. Un elemento recién insertado no tiene estado previo desde el que
  // transicionar → su 'transition: width' NUNCA llegaba a correr y la barra
  // pegaba un salto seco (verificado: el fill viejo sale del DOM, isConnected=false).
  // Aquí le damos el punto de partida que le faltaba: lo pintamos en el % anterior
  // y en el frame siguiente lo soltamos hacia el nuevo, y ya sí transiciona.
  (function () {
    var lastPct = null;
    var busy = false; // ignora las mutaciones que provocamos nosotros mismos
    function checkFill() {
      if (busy) return;
      var el = document.querySelector('cart-drawer .sh-cart-progress__fill');
      if (!el) { lastPct = null; return; }
      var target = el.style.width;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (lastPct !== null && target && target !== lastPct && !reduce) {
        busy = true;
        // OJO: hay que matar la transición para el reset. Si no, el propio
        // 'transition: width' anima también el salto hacia atrás (target→lastPct),
        // el reflow pilla el valor a medio camino y al soltar no queda recorrido
        // que animar. Con transition:none el punto de partida se aplica de golpe.
        el.style.transition = 'none';
        el.style.width = lastPct;
        void el.offsetWidth; // reflow: fija el punto de partida ya aplicado
        el.style.transition = ''; // devuelve el 'width .5s' del CSS
        requestAnimationFrame(function () {
          el.style.width = target;
          busy = false;
        });
      }
      lastPct = target;
    }
    var fillHost = document.querySelector('cart-drawer');
    if (fillHost && 'MutationObserver' in window) {
      new MutationObserver(checkFill).observe(fillHost, { childList: true, subtree: true });
      checkFill();
    }
  })();
})();
